// Load popup configs based on current language

require('../../../vendor/jquery.waypoints.js');
require('../../../vendor/jquery-cookie-plugin.js');
require('../../../vendor/jquery-validation/jquery.validate.min.js');


const locale = $('html').attr('lang');

const Translator = require('bazinga-translator');
const translations = require('./translations/' + locale + '.json');
Translator.fromJSON(translations);

let config = null;

switch (locale) {

    case 'en':
        config = require('./config/en.js')();
        break;

    case 'de':
        config = require('./config/de.js')();
        require('../../../vendor/jquery-validation/localization/messages_de.min.js');
        break;

    case 'nl':
        config = require('./config/nl.js')();
        require('../../../vendor/jquery-validation/localization/messages_nl.min.js');
        break;

	case 'fr':
		config = require('./config/fr.js')();
		require('../../../vendor/jquery-validation/localization/messages_fr.min.js');
		break;

	case 'es':
		config = require('./config/es.js')();
		require('../../../vendor/jquery-validation/localization/messages_es.min.js');
		break;

    case 'it':
        config = require('./config/it.js')();
        require('../../../vendor/jquery-validation/localization/messages_it.min.js');
        break;
}

// Popups
//
// Popups can be displayed on any page.

const _Popups = {

    module: '.jsPopup',
    close: '.jsPopupClose',
    overlay: '.jsPopupBg',
    closeButton: '.jsPopupClose',
    submit: '.jsPopupSubmit',
    form: '#newsletterPopupForm',
    formName: 'newsletterPopupForm',
    content: ' .Popup__content__form',
    titleDiv: '.Popup__title',
    subTitleDiv: '.Popup__subTitle',
    imageTitleDiv: '.Popup__content__image__title',
    magazineTypeInput: '#magazine_type',
    settings: config.frontend_config,

    init: function () {

        // Get configuration form settings and render popup
        _Popups.prepare_popup();

        // Run click event
        _Popups.click_close();

        // If window orientation changes (mobile)
        $(window).on('resize', function () {
            _Popups.set_position();
        });

        _Popups.init_form_validation();

    },

    init_form_validation: function () {
        $("form[name='" + _Popups.formName + "']").validate({
            rules: {
                subscriber_name: "required",
                subscriber_email: {
                    required: true,
                    email: true
                }
            },
            submitHandler: function (form, event) {
                event.preventDefault();
                _Popups.submit_click(form);
            }
        });
    },

    get_popups_amount: function () {
        return _Popups.settings.length;
    },

    show_popup: function () {


        // Add class to popup and popup background
        $(_Popups.module).addClass('active');
        $(_Popups.overlay).addClass('active');
        $(_Popups.closeButton).addClass('active');

        // This sets verical centering
        _Popups.set_position('show');
    },

    hide_popup: function () {

        //Remove active clasess
        $(_Popups.module).removeClass('active');
        $(_Popups.overlay).removeClass('active');
        $(_Popups.closeButton).removeClass('active');

        // This will reset previous values
        _Popups.set_position('hide');
    },

    set_position: function (type = 'default') {

        // Elements
        const element = $(_Popups.module);
        const body = $(window);

        // Get modal size
        const h = element.height();

        // Get window size
        const bh = body.height();

        switch (type) {
            case 'show':

                // Update the css and center the popup on screen
                element.css({"top": ((bh - h) / 2) + "px"});

                break;

            case 'hide':

                // Update the css and hide popup
                element.css({"top": "150%",});

                break;

            case 'default':
                // If popup is active, center it again
                if (element.hasClass('active')) {
                    element.css({"top": ((bh - h) / 2) + "px",});
                }

                break;
        }
        ;

    },

    popup_type: function (type, value) {


        switch (type) {

            case 'timer':

                setTimeout(function () {
                    _Popups.show_popup();
                }, value);

                if (!$.cookie('newsletterPopups')) {
                    $.cookie('newsletterPopups', true, {expires: 14, path: '/'});
                }
                break;

            case 'scroll':

                // Desired percentage from popup settings
                let desired_offset = `-${value}%`;

                // This is element for offset detection - by default <header>
                const realtive_element = $('.top-wrapper');

                const waypoint = new Waypoint({
                    element: realtive_element,
                    handler: function (direction) {
                        _Popups.show_popup();
                        waypoint.destroy(); // fire only once
                    },
                    offset: desired_offset
                });

                if (!$.cookie('newsletterPopups')) {
                    $.cookie('newsletterPopups', true, {expires: 14, path: '/'});
                }
                break;

        }

    },

    prepare_popup: function () {

        let popup_settings = null;

        // Loop through each popup from file
        for (let popup in _Popups.settings) {

            const single = _Popups.settings[popup];

            // Get settings and pass them to render function
            for (let settings in single) {

                popup_settings = single[settings];

                if (typeof popup_settings.enabled_on !== 'undefined' && popup_settings.enabled_on.length > 0) {

                    for (let i in popup_settings.enabled_on) {

                        const location = window.location.href.replace(/.*\/\/[^\/]*/, '');
                        const url_rule = popup_settings.enabled_on[i].endsWith("*") ? popup_settings.enabled_on[i].slice(0, -1) : popup_settings.enabled_on[i];

                        if (location.indexOf(url_rule) > -1) {
                            _Popups.pre_render_popup(popup_settings);
                            break;
                        }
                    }
                }

            }

        }

    },

    pre_render_popup: function (popup_settings) {

        // settings
        let enabled_on = popup_settings['enabled_on'];
        let on_scroll = popup_settings['scroll_percent'];
        let time_amount = popup_settings['timer'];
        const cookieValue = $.cookie('newsletterPopups');
        let title = typeof popup_settings['title'] !== 'undefined' ? popup_settings['title'] : null;
        let subtitle = typeof popup_settings['subtitle'] !== 'undefined' ? popup_settings['subtitle'] : null;
        let imageTitle = typeof popup_settings['image_title'] !== 'undefined' ? popup_settings['image_title'] : null;
        let magazine_type = typeof popup_settings['magazine_type'] !== 'undefined' ? popup_settings['magazine_type'] : 'generic';


        $(_Popups.magazineTypeInput).val(magazine_type);

        if (title != null) {
            $(_Popups.titleDiv).html(title);
        }

        if (subtitle != null) {
            $(_Popups.subTitleDiv).html(subtitle);
        }

        if (imageTitle != null) {
            $(_Popups.imageTitleDiv).html(imageTitle);
        }

        // Setup vars
        let type;
        let value;
        if (on_scroll !== false) {
            type = 'scroll';
            value = on_scroll;
        }

        if (time_amount !== false) {
            type = 'timer';
            value = time_amount;
        }

        if (typeof cookieValue === "undefined") {
            _Popups.render_popup(enabled_on, type, value);
        }

        // Close on outside click
        let outside_close = popup_settings['outside_close'];
        if (outside_close !== false) _Popups.click_outside();

    },

    render_popup: function (sites, type, value) {


        for (let single in sites) {

            const url_to_match = sites[single];
            const location = window.location.href.replace(/.*\/\/[^\/]*/, '');

            // If url corresponds with settings

            if (
                // if ends with asterisk -> all sub-urls
                (url_to_match.endsWith('*') && (location.indexOf(url_to_match.substring(0, url_to_match.length - 1)) > -1))

                || // ends with the exactly given string
                (location.endsWith(url_to_match))

            ) {

                _Popups.popup_type(type, value);

            }

        }

    },

    click_outside: function () {
        const $win = $(window);
        const $box = $(_Popups.module);

        $win.on("click", function (event) {
            // OUTSIDE
            if (
                $box.has(event.target).length == 0 //checks if descendants of $box was clicked
                &&
                !$box.is(event.target) //checks if the $box itself was clicked
            ) {
                _Popups.hide_popup();
            }
        });
    },

    click_close: function () {
        $(_Popups.close).on('click', function (e) {
            e.preventDefault();
            _Popups.hide_popup();
        });
    },

    submit_click: function (form) {

        $("#newsletterPopupForm").append(
            "<div class='alert alert-warning' style='text-align: center; margin-top: 2px;'>" + Translator.trans("info.processing") + " <i class=\"fa fa-spinner fa-spin\"></i></div>"
        );

        $(".Popup__submit.jsPopupSubmit").attr("disabled", "disabled");

        $.ajax({
            type: $(form).attr('method'),
            url: $(form).attr('action'),
            data: $(form).serialize(),
            success: function (receivedData) {
                if (receivedData.status === 'ok') {
                    $('.Popup__content__form').html(
                        "<div class=\"alert alert-success\">" + Translator.trans("info.success") + "</div>\n" +
                        "    <button class=\"popup-close-btn btn btn-primary btn-block\">" + Translator.trans("button.close") + "</button>"
                    );
                } else {
                    $('.Popup__content__form').html(
                        "<div class=\"alert alert-danger\">" + Translator.trans("info.error") + "</div>\n" +
                        "    <button class=\"popup-close-btn btn btn-primary btn-block\">" + Translator.trans("button.close") + "</button>"
                    );
                }

                $('.popup-close-btn').on('click', function (e) {
                    e.preventDefault();
                    _Popups.hide_popup();
                });
            },
            error: function (jqXHR, textStatus, errorThrown) {
            },
            dataType: "json"
        });


    }

};


$(document).ready(function () {

	if (locale != 'fr' && locale != 'es') {
		_Popups.init();
	}

});
